import type { BadgeVariant } from "../../../ui/badge/badge.tsx";

export function statusBadgeVariant(status: string | null | undefined): BadgeVariant {
  const normalized = (status ?? "").trim().toUpperCase();
  if (normalized === "ACTIVE" || normalized === "VERIFIED") return "success";
  if (normalized === "PENDING") return "warning";
  if (normalized === "INACTIVE" || normalized === "REJECTED") return "danger";
  return "neutral";
}

export function formatStatusLabel(status: string | null | undefined): string {
  const value = (status ?? "").trim();
  if (!value) return "-";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
